import React  from "react";
import {Button, Popover, MenuItem, Menu, Position} from "@blueprintjs/core";

const CurrencySelect=({current_currency, currencyChanged})=>{ 
    return(
        <Popover
            content={
                <Menu>
                    <MenuItem text="SEK" onClick={()=>{currencyChanged("SEK")}} />
                    <MenuItem text="EUR" onClick={()=>{currencyChanged("EUR")}} />
                </Menu>
            }
            position={Position.BOTTOM_RIGHT}
        >
            <Button rightIcon="caret-down" className="input-button right">
                {current_currency}
            </Button>
        </Popover>
    );
}

export default CurrencySelect;